import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormInput = _resolveComponent("FormInput");
    const _component_FormWrapper = _resolveComponent("FormWrapper");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        infoPayload: _ctx.infoPayload,
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.open) = $event)),
        cancelBtnTxt: "Cancel",
        actionBtnTxt: "Load",
        onOnPopupDone: _ctx.onPopupDone,
        isActionBtnEnabled: _ctx.isBtnEnabled(),
        onOnUserArgChanged: _ctx.onUserArgChanged
    }, {
        default: _withCtx(() => [
            _createVNode(_component_FormWrapper, null, {
                default: _withCtx(() => [
                    _createVNode(_component_FormInput, {
                        ref: "formMolName",
                        id: "formMolName",
                        modelValue: _ctx.molName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.molName) = $event)),
                        placeHolder: "(Optional) The Chemical Name (e.g., Aspirin)...",
                        onOnChange: _ctx.searchByName,
                        delayBetweenChangesDetected: 2000,
                        description: _ctx.molNameRespDescription,
                        validateDescription: false
                    }, null, 8, ["modelValue", "onOnChange", "description"])
                ]),
                _: 1
            }),
            _createVNode(_component_FormWrapper, null, {
                default: _withCtx(() => [
                    _createVNode(_component_FormInput, {
                        ref: "formCID",
                        modelValue: _ctx.cid,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.cid) = $event)),
                        id: "cid",
                        placeHolder: "The CID (e.g., 2244)...",
                        filterFunc: _ctx.filterUserData,
                        onOnKeyDown: _ctx.onCIDKeyDown,
                        description: "The CID number. Search <a href=\"https://pubchem.ncbi.nlm.nih.gov/\" target=\"_blank\">PubChem</a> to find the CID yourself."
                    }, null, 8, ["modelValue", "filterFunc", "onOnKeyDown"])
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["infoPayload", "modelValue", "onOnPopupDone", "isActionBtnEnabled", "onOnUserArgChanged"]));
}
